import {
  SET_VISIBILITY,
  SET_SHOW_NEXT_BUTTON,
  SET_HIDE_VALIDATION
} from './actionTypes';

const initialState = {
  visibility: true,
  showNextButton: false,
  hideValidation: false
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {

    case SET_VISIBILITY:
      return {
        ...state,
        visibility: action.visibility
      };

    case SET_SHOW_NEXT_BUTTON:
      return {
        ...state,
        showNextButton: action.showNextButton
      };

    case SET_HIDE_VALIDATION:
      return {
        ...state,
        hideValidation: action.hideValidation
      };

    default:
      return state;
  }
};